import AjaxForm, {EVENT_SUCCESS} from "webPage/AjaxForm";
import QuizStep from "util/QuizStep";
import RecaptchaHelper from "RecaptchaHelper";
import PageAnimations from "webPage/PageAnimations";

export default class Quiz {
    constructor($element) {
        this.$element = $element;
        this.$progress = this.$element.find('.js-progress');
        this.steps = [];
        this.isShutters = false;
        this.stepIndex = 0;

        this.bindEvents();
        this.updateProgressBar();
    }

    bindEvents() {
        let me = this;

        RecaptchaHelper.load().then(() => {
            RecaptchaHelper.init(this.$element);

            this.form = new AjaxForm(this.$element.find('.js-form'), async ($form, formData) => {

                let path = this.isShutters ? Quiz.quizPaths.shutters : Quiz.quizPaths.default;
                path.forEach((value, index) => {
                    formData = $.extend({}, formData, this.steps[value].getData());
                });

                const response = await RecaptchaHelper.validate().then((captcha) => {
                    formData.captcha = captcha;
                    return Ajax.post('leamington-blinds', 'quiz', formData);
                });

                if (response.status !== 'success') {
                    throw response;
                }
                return response;
            }).on(EVENT_SUCCESS, (data) => {
                let token = data['quiz_result'].token;
                if ('undefined' === typeof token) {
                    console.warn('Invalid token value returned', data);
                }
                let url = '/quiz?result=' + token;
                let winning_product = data['quiz_result'].winner.name;

                try {
                    dataLayer.push({
                        'event': 'quote-submit',
                        'winning-product': winning_product,
                        'eventCallback': function () {
                            window.location.href = url;
                        }
                    });
                } catch (e) {
                    console.log(e);
                    window.location.href = url;
                }
            });
        });

        this.$element.find('.js-step').each(function () {
            let step = new QuizStep($(this));

            step.on('updateIsShutters', (isShutters) => {
                me.isShutters = isShutters;
                me.reorderSteps();
            });

            step.on('nextStep', (step) => {
                me.nextStep();
            });

            step.on('previousStep', (step) => {
                me.previousStep();
            });

            me.steps.push(step);
        });

        this.$element.find('.js-form').on('click', '.js-previous', () => {
            this.previousStep();
            return false;
        });
    }

    reorderSteps() {
        let path = this.isShutters ? Quiz.quizPaths.shutters : Quiz.quizPaths.default;
        path.forEach((value, index) => {
            this.$element.find('.js-step').eq(value).find('.js-question').text('Question ' + (index + 1));
        });
        this.$element.find('.js-form .js-question').text('Question ' + (path.length + 1));
    }

    nextStep() {
        this.stepIndex++;
        this.showActiveStep();
    }

    previousStep() {
        this.stepIndex--;
        this.showActiveStep('previous');
    }

    showActiveStep(direction = 'next') {
        let path = this.isShutters ? Quiz.quizPaths.shutters : Quiz.quizPaths.default;
        let index = Math.max(0, Math.min(this.stepIndex, path.length));
        let activeIndex = path[index];

        let $active_step = this.$element.find('.quiz-form__step--active');
        let old_height = $active_step.find('.js-form-top').outerHeight();

        let $next_step = null;
        if (this.stepIndex >= path.length) {
            //Have reached the end of the questions show details form
            $next_step = this.$element.find('.js-form');
        } else {
            $next_step = this.$element.find('.js-step').eq(activeIndex);
        }

        if ($next_step === null) {
            console.warn("Could not find the next step of the quiz", {index: this.stepIndex});
            return;
        }

        let $next_step_top = $next_step.find('.js-form-top');

        this.$element.find('.js-step, .js-form').removeClass('quiz-form__step--active a--play');
        $next_step.removeClass('a--play').addClass('quiz-form__step--active a');

        let native_size = $next_step_top.outerHeight();

        $next_step_top.css({height: old_height});

        $next_step_top.find('.js-animate').each(function () {
            let $this = $(this);
            let delay = Math.max(0, parseInt($this.attr('data-delay')) - 200);

            $this.addClass('a__i a__i--fade-in-right-quiz a__i--dur-300 a__i--delay-' + delay);
        });

        PageAnimations.check();

        setTimeout(() => {
            $next_step_top.animate({
                height: native_size,
            }, {
                duration: 200,
                complete: () => {
                    // Reset the styles back to their defaults
                    $next_step_top.css("height", "");
                },
            });
        });

        this.updateProgressBar();
    }

    updateProgressBar() {
        let path = this.isShutters ? Quiz.quizPaths.shutters : Quiz.quizPaths.default;
        let percentage = ((this.stepIndex + 1) / (path.length + 1)) * 100;
        this.$progress.find('span').css({width: percentage + '%'});
    }
}

Quiz.quizPaths = {'default': [0, 1, 3, 4], 'shutters': [0, 1, 2, 3, 4]}